const change_manage = [
    {path: 'change-manage/ChangeManagement', meta: { name: "创建变更"}},
]
  
export default change_manage


// WEBPACK FOOTER //
// ./src/router/mapping/change-manage.js